import { Record } from "../../fable_modules/fable-library.3.7.20/Types.js";
import { class_type, list_type, record_type, float64_type, option_type, string_type, int32_type } from "../../fable_modules/fable-library.3.7.20/Reflection.js";
import { UTC__toDateTimeOffset, UTC$reflection } from "../../fable_modules/Svea.Dry.Fable.1.0.4/Time.fs.js";
import { DateTimeOffsetExtensions_toDateHHmmss } from "../../Utils.js";
import { join } from "../../fable_modules/fable-library.3.7.20/String.js";
import { empty, singleton, append, delay, toList } from "../../fable_modules/fable-library.3.7.20/Seq.js";
import { value } from "../../fable_modules/fable-library.3.7.20/Option.js";

export class SuspenseRowDTO extends Record {
    constructor(NetworkContractNr, PortNr, Name, A_Number, Imsi, MinStartTime, MaxStartTime, N, OrigCostExclVat) {
        super();
        this.NetworkContractNr = (NetworkContractNr | 0);
        this.PortNr = (PortNr | 0);
        this.Name = Name;
        this.A_Number = A_Number;
        this.Imsi = Imsi;
        this.MinStartTime = MinStartTime;
        this.MaxStartTime = MaxStartTime;
        this.N = (N | 0);
        this.OrigCostExclVat = OrigCostExclVat;
    }
}

export function SuspenseRowDTO$reflection() {
    return record_type("Containers.Suspense.Model.SuspenseRowDTO", [], SuspenseRowDTO, () => [["NetworkContractNr", int32_type], ["PortNr", int32_type], ["Name", string_type], ["A_Number", option_type(string_type)], ["Imsi", option_type(string_type)], ["MinStartTime", UTC$reflection()], ["MaxStartTime", UTC$reflection()], ["N", int32_type], ["OrigCostExclVat", option_type(float64_type)]]);
}

export function renderUtcDate(locale, utc) {
    return DateTimeOffsetExtensions_toDateHHmmss(locale.ILocale, UTC__toDateTimeOffset(utc));
}

function getSearchFriendlyString(locale, row) {
    return join("|", toList(delay(() => append((row.A_Number != null) ? singleton(value(row.A_Number)) : empty(), delay(() => append((row.Imsi != null) ? singleton(value(row.Imsi)) : empty(), delay(() => append(singleton(renderUtcDate(locale, row.MinStartTime)), delay(() => singleton(renderUtcDate(locale, row.MaxStartTime)))))))))));
}

export class SuspenseRow extends Record {
    constructor(NetworkContractNr, PortNr, Name, A_Number, Imsi, MinStartTime, MaxStartTime, N, OrigCostExclVat, SearchFriendlyString) {
        super();
        this.NetworkContractNr = (NetworkContractNr | 0);
        this.PortNr = (PortNr | 0);
        this.Name = Name;
        this.A_Number = A_Number;
        this.Imsi = Imsi;
        this.MinStartTime = MinStartTime;
        this.MaxStartTime = MaxStartTime;
        this.N = (N | 0);
        this.OrigCostExclVat = OrigCostExclVat;
        this.SearchFriendlyString = SearchFriendlyString;
    }
}

export function SuspenseRow$reflection() {
    return record_type("Containers.Suspense.Model.SuspenseRow", [], SuspenseRow, () => [["NetworkContractNr", int32_type], ["PortNr", int32_type], ["Name", string_type], ["A_Number", option_type(string_type)], ["Imsi", option_type(string_type)], ["MinStartTime", UTC$reflection()], ["MaxStartTime", UTC$reflection()], ["N", int32_type], ["OrigCostExclVat", option_type(float64_type)], ["SearchFriendlyString", string_type]]);
}

export function SuspenseRow_FromDTO(locale, dto) {
    return new SuspenseRow(dto.NetworkContractNr, dto.PortNr, dto.Name, dto.A_Number, dto.Imsi, dto.MinStartTime, dto.MaxStartTime, dto.N, dto.OrigCostExclVat, getSearchFriendlyString(locale, dto));
}

export class CorrectionRequestDTO extends Record {
    constructor(NetworkContractNr, Numbers, Imsis) {
        super();
        this.NetworkContractNr = (NetworkContractNr | 0);
        this.Numbers = Numbers;
        this.Imsis = Imsis;
    }
}

export function CorrectionRequestDTO$reflection() {
    return record_type("Containers.Suspense.Model.CorrectionRequestDTO", [], CorrectionRequestDTO, () => [["NetworkContractNr", int32_type], ["Numbers", list_type(string_type)], ["Imsis", list_type(string_type)]]);
}

export class CorrectionRowData extends Record {
    constructor(Imsi, CountryCode, ActiveFrom, ActiveTo, ContractNr, NumberFrom) {
        super();
        this.Imsi = Imsi;
        this.CountryCode = CountryCode;
        this.ActiveFrom = ActiveFrom;
        this.ActiveTo = ActiveTo;
        this.ContractNr = ContractNr;
        this.NumberFrom = NumberFrom;
    }
}

export function CorrectionRowData$reflection() {
    return record_type("Containers.Suspense.Model.CorrectionRowData", [], CorrectionRowData, () => [["Imsi", option_type(class_type("System.Decimal"))], ["CountryCode", string_type], ["ActiveFrom", UTC$reflection()], ["ActiveTo", option_type(UTC$reflection())], ["ContractNr", class_type("System.Decimal")], ["NumberFrom", string_type]]);
}

export class CorrectionResponse extends Record {
    constructor(Error$, Result) {
        super();
        this.Error = Error$;
        this.Result = Result;
    }
}

export function CorrectionResponse$reflection() {
    return record_type("Containers.Suspense.Model.CorrectionResponse", [], CorrectionResponse, () => [["Error", option_type(string_type)], ["Result", list_type(CorrectionRowData$reflection())]]);
}

export class MakeCorrectionResponse extends Record {
    constructor(Error$, Result) {
        super();
        this.Error = Error$;
        this.Result = Result;
    }
}

export function MakeCorrectionResponse$reflection() {
    return record_type("Containers.Suspense.Model.MakeCorrectionResponse", [], MakeCorrectionResponse, () => [["Error", option_type(string_type)], ["Result", option_type(string_type)]]);
}

export class MakeCorrectionDTO extends Record {
    constructor(CountryCode, ContractNr, ActiveFrom, ActiveTo, Imsi, ActiveFromCorrection, ActiveToCorrection) {
        super();
        this.CountryCode = CountryCode;
        this.ContractNr = (ContractNr | 0);
        this.ActiveFrom = ActiveFrom;
        this.ActiveTo = ActiveTo;
        this.Imsi = Imsi;
        this.ActiveFromCorrection = ActiveFromCorrection;
        this.ActiveToCorrection = ActiveToCorrection;
    }
}

export function MakeCorrectionDTO$reflection() {
    return record_type("Containers.Suspense.Model.MakeCorrectionDTO", [], MakeCorrectionDTO, () => [["CountryCode", string_type], ["ContractNr", int32_type], ["ActiveFrom", string_type], ["ActiveTo", string_type], ["Imsi", option_type(class_type("System.Int64"))], ["ActiveFromCorrection", string_type], ["ActiveToCorrection", string_type]]);
}

